
import makeStyles from '@material-ui/styles/makeStyles';

const style = makeStyles(() => ({
    imageWidth: {
        '& img': {
            width: 'calc(100% - 10px)',
            height: '250px',
            objectFit: 'cover',
            objectPosition: 'right',
            background: '#fff',
            padding: '6px',
        },

    },
    contetnArrange: {
        textcolor: 'black',
        width: '100%',
        padding: '10px 10px',
        border: '1px',
        boxShadow: '0 0 5px #eee',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        boxSizing: 'border-box',
        color: '#666',
        marginBottom: '-20px',
    },
    manageListStyle: {
        boxShadow: '0 0 2px #eee',
        '& img': {
            width: '100%',
        }
    },

}));

export default style;
